<template>
  <div
    v-if="state.active"
    class="glo-backdrop"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="glo-card">
      <div class="glo-spinner" aria-hidden="true">
        <span class="glo-spinner__ring glo-spinner__ring--outer"></span>
        <span class="glo-spinner__ring glo-spinner__ring--inner"></span>
        <div class="glo-spinner__core">
          <img :src="logoSrc" alt="" class="glo-spinner__logo" />
        </div>
      </div>

      <div class="glo-copy">
        <p class="glo-text">{{ state.text || 'Cargando...' }}</p>
        <small class="glo-subtext">Orderly esta procesando tu solicitud</small>
      </div>
    </div>
  </div>
</template>

<script>
import { loadingState } from "@/plugins/loading";
import logoSrc from "@/assets/images/logo/minilogo.png";

export default {
  name: "GlobalLoadingOverlay",
  data() {
    return {
      state: loadingState,
      logoSrc,
    };
  },
};
</script>

<style scoped>
.glo-backdrop{
  position: fixed;
  inset: 0;
  background: radial-gradient(circle at 50% 25%, rgba(0, 112, 205, 0.2), rgba(15, 23, 42, 0.72));
  backdrop-filter: blur(3px);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.glo-card{
  background: linear-gradient(160deg, #ffffff 0%, #f3f8ff 100%);
  border: 1px solid rgba(0, 112, 205, 0.3);
  border-radius: 14px;
  padding: 18px 20px;
  min-width: 260px;
  max-width: 80vw;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.35);
}

.glo-spinner {
  position: relative;
  width: 58px;
  height: 58px;
  flex-shrink: 0;
}

.glo-spinner__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border-style: solid;
  border-color: transparent;
}

.glo-spinner__ring--outer {
  border-width: 4px;
  border-top-color: #0070cd;
  border-right-color: rgba(0, 112, 205, 0.45);
  animation: glo-spin 1s linear infinite;
}

.glo-spinner__ring--inner {
  inset: 8px;
  border-width: 3px;
  border-bottom-color: #0f3f77;
  border-left-color: rgba(15, 63, 119, 0.4);
  animation: glo-spin-reverse 1.4s linear infinite;
}

.glo-spinner__core {
  position: absolute;
  inset: 14px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px rgba(0, 112, 205, 0.12);
}

.glo-spinner__logo {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.glo-copy {
  display: grid;
  gap: 2px;
}

.glo-text{
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.glo-subtext {
  font-size: 12px;
  color: #475569;
}

@keyframes glo-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes glo-spin-reverse {
  to {
    transform: rotate(-360deg);
  }
}
</style>
